<template>
  <div class="stack-container" :style="containerStyle">
    <img
      v-for="(image, index) in visibleImages"
      :key="index"
      :src="image"
      :alt="`Image ${index + 1}`"
      class="stacked-image"
      :style="getStackStyle(index, visibleImages.length)"
    />
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true,
      default: () => [],
    },
    size: {
      type: Number,
      default: 100,
    },
    maxVisible: {
      type: Number,
      default: 7, // Show at most 7 images in the stack
    },
  },
  data() {
    return {
      placeholder_image: 'https://www.svgrepo.com/show/508699/landscape-placeholder.svg',
    }
  },
  computed: {
    visibleImages() {
      const len = this.images.length
      let x = this.images.filter((image) => image) //remove the ones that don't have an image
      x = x.slice(0, this.maxVisible) //take the first x

      //n is the number of images we want to show (at least 1, and min between maxVisible and original list)
      const n = Math.max(1, Math.min(len, this.maxVisible))
      //backfill
      for (let i = x.length; i < n; i++) {
        x.push(this.placeholder_image)
      }

      //scrappy fix for AutoCrop images from amazon to force square images here!
      for (let i = 0; i < x.length; i++) {
        const im = x[i]
        if (im.includes('amazon')) {
          x[i] = im.replace('_AC_SY300_', '_AC_SR250,250_')
        }
      }

      //remove empty strings from the array
      return x
    },
    containerStyle() {
      // Container should be slightly larger than one image to accommodate small offsets
      const padding = this.size * 0.3 // 30% extra space around
      return {
        width: `${this.size + padding}px`,
        height: `${this.size + padding}px`,
      }
    },
  },
  methods: {
    getStackStyle(index, total) {
      const isTop = index === 0

      if (isTop) {
        return {
          zIndex: total,
          transform: 'none',
        }
      }

      // Dynamic offset: smaller when there are more images
      const baseOffset = this.size * 0.08 // 8% of image size per layer
      const layerFromBottom = index
      const offset = baseOffset * layerFromBottom

      // Rotation: smaller and more random feel, but reduced with more layers
      const maxRotation = Math.min(12, 15 - layerFromBottom * 1.5)
      const rotation = layerFromBottom * 3 - 8 + (Math.random() * 4 - 2) // slight randomness

      return {
        zIndex: index,
        transform: `translate(${offset}px, ${offset}px) rotate(${rotation}deg)`,
      }
    },
  },
}
</script>

<style scoped>
.stack-container {
  position: relative;
  display: inline-block; /* Shrinks to content */
}

.stacked-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 4px solid white;
  border-radius: 4px; /* Optional: softer look */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s ease, box-shadow 0.3s ease, z-index 0.3s;
}

.stacked-image:hover {
  transform: translateY(-10px) scale(1.05) !important;
  box-shadow: 0 20px 30px rgba(0, 0, 0, 0.4);
  z-index: 999 !important;
}
</style>
